import React from "react";

const GrowBusinessOnline: React.FC = () => {
  return (
    <div style={{ padding: "40px 6%", maxWidth: "900px", margin: "0 auto" }}>
      <h1 style={{ fontSize: "2rem", fontWeight: 800 }}>
        How to Grow Your Business Online
      </h1>

      <p style={{ color: "#777", marginBottom: "30px" }}>
        March 2026 • 5 min read
      </p>

      <p>
        Growing a business online requires strategy, consistency, and the right
        tools.
      </p>

      <h2>1. Build Your Presence</h2>
      <p>Use social media and SEO to reach your audience.</p>

      <h2>2. Use Automation</h2>
      <p>Save time by automating repetitive tasks.</p>

      <h2>3. Track Performance</h2>
      <p>Measure results and optimize your strategy.</p>

      <h2>Final Thoughts</h2>
      <p>Focus on consistency and data-driven decisions to grow faster.</p>
    </div>
  );
};

export default GrowBusinessOnline;
